import React from 'react'

const Alerts = ({ alerts, fromMobiView = false }) =>
  alerts.map((alert, i) => (
    <Alert
      key={i}
      alert={alert}
      fromMobiView={fromMobiView}
    />
  ))

const Alert = ({ alert, fromMobiView }) => {
  return (
    <div
      className='yellow-bordered-content'
      tabIndex={0}
    >
      <h4>{alert.name}</h4>

      {alert.description && (
        <p
          className="m-0 text-16 leading-tight"
          dangerouslySetInnerHTML={{
            __html: alert.description
          }}
        >
          {}
        </p>
      )}
    </div>
  )
}

export default Alerts
